module.exports = __webpack_public_path__ + "img/xiaomi12timage5.9488287b.png";